import { ReportsContainer } from "../ReportsContainer";

export const AverageTimeReport = () => {
  return (
    <ReportsContainer>
    </ReportsContainer>
  );
};
